<template>
    <form>
        <h3>Section Four - Parent / Guardian Details</h3>
        <label class="full2"><span>Parent / Guardian First Names</span><input required name="pgfirstnames" v-model="$parent.rec.pgfirstnames"></label>
        <label class="full2"><span>Parent / Guardian Last Name</span><input required name="pglastname" v-model="$parent.rec.pglastname"></label>
        <label class="full2"><span>Relationship to student</span><input required name="pgrelationship" v-model="$parent.rec.pgrelationship"></label>
        <label class="full2"><span>Parent / Guardian Mobile Phone</span><input required name="pgmobilephone" v-model="$parent.rec.pgmobilephone"></label>
        <label class="full2"><span>Parent / Guardian Email</span><input required name="pgemail" type="email" v-model="$parent.rec.pgemail"></label>
        <footer><button @click.prevent="$parent.prevTab">Back</button><button @click.prevent="$parent.nextTab">Next</button></footer>
    </form>
</template>

<script>
export default {
    name:"section 4",
    components:{},
    data: function (){return {
    }},
    methods:{
        allGood: function(){
            let notfilled = [
                "pgfirstnames",
                "pglastname",
                "pgrelationship",
                "pgmobilephone",
                "pgemail"].map(u=>this.$parent.rec[u]).filter(u=>u=="");
            if (notfilled.length==0)
                return true;
            return false;
        }
    }
}
</script>

<style>
</style>